<template>
    <FilterExpandCollapse label="Hospital affiliations" v-if="filterContext.type === 'doctor'">
         <BaseFCPAutoComplete2
            elementId="hospital-affiliations"
            :options="autoCompleteOptions"
            label="Select a hospital group"
            :hideSearchButton="true"
            v-on:onSelected="onAffiliatedHospitalSelected"
            v-on:onInputChange="onAutoCompleteInputChange"
            :initialValue="filterContext.hLabel"
            :showOptionalLabel="false"
        />
      <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
      <div>
        <BaseFCPGeoLocator
          :id="`geoCoder-for-hosAff`"
          label="near city/state or zip"
          v-on:selected="onSelected"
          v-on:inputchange="onInput"
          :showOptionalLabel="false"
          :initial-value="initialValue"
          helpText="ZIP or City, State"
        />
        <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
        <BaseFCPTextSelect
          :key="key"
          elementId="distance-hosp-affil"
          label="with in"
          labelSize="xs"
          :items="options"
          v-model="filterContext.hDistance"
        />
      </div>
    </FilterExpandCollapse>
</template>
<script setup>

      const model = useFCPModel()
      const { reverseGeoLocate, geoLocate } = useGeolocation()
      const { profile, filterContext, networkId, context, criteriaContext, plan, mapboxToken } = model
      const initialValue = ref('')
      const { loadHospitalAffiliations } = useApi()
      const options = [
        { label: '5 miles', value: 5 },
        { label: '10 miles', value: 10 },
        { label: '20 miles', value: 20 },
        { label: '50 miles', value: 50 },
        { label: '75 miles', value: 75 },
      ]

    const key = computed(() => (options.value ? JSON.stringify(options.value) : 'default_key'))
    const filterCtxt = computed(() => filterContext.value)
    const latitude = ref('')
    const longitude = ref('')
    const zip = ref('')
    const hospitalaffitems =  ref([])
    const asOfDate = context.value.asOfDate
    const groupId = plan.value.coverageInfo != null ? plan.value.coverageInfo.groupNumber : ''
    filterContext.value.hDistance = criteriaContext.value.distance
    const distance = computed(() => filterContext.value.hDistance)
  
    const onSelected = (event) => {
      if ( event ) {
        latitude.value = event.latitude
        longitude.value = event.longitude
        //zip.value = event.zip
      }
      else {
        latitude.value = ''
        longitude.value = ''
      }
    }
  
    //Listen for changes on) the input field of the geocoder.  If it changes, clear out the latLong.  The user must select a new
    //entry from the list, otherwise they can type something in the field and hit search thinking they have a new search such as a new
    //zip code.  In reality, they would be seeing the resuults from the latLong from the previous search.  To prevent this, clear out
    //the latLong anytime the user types into the input field.  When an entry is selected from the list, a new latLong will be applied.
    const onInput = () => {
        latitude.value = ''
        longitude.value = ''
    }

    const onAutoCompleteInputChange = (input) => {
      if (!input){
        filterContext.value.hLabel = ''
        filterContext.value.hCode = ''
      }
    }

   const onAffiliatedHospitalSelected = (event) => {
      filterContext.value.hLabel = event ? event.label : ''
      filterContext.value.hCode = event ? event.code : ''
   }
  
  const loadHospitalAffData = async () => {
    const results = await loadHospitalAffiliations(networkId.value, latitude.value, longitude.value, filterContext.value.hDistance, groupId, asOfDate)
    let filteredHospitals = []

    if ( results && results.locations ) {
      filteredHospitals = results.locations.map( l => {
        return { label: l.name, code: l.id }
      })
    } 
      
    hospitalaffitems.value = filteredHospitals
  }

    watch([filterCtxt], () => {
        if (context.value.type == 'doctor') loadHospitalAffData()
    })

    // Watch for changies in lat/long.  If they change, reload the hospital affiliation list.
    watch([latitude, longitude], () => {
        loadHospitalAffData()
    })

    // Watch for changies in distacne.  If the distance changes and a lat/long has been selected, 
    //reload the hospital affiliation list.
    watch(distance, () => {
      console.log("Distance changed!!")
      if ( latitude.value && longitude.value ) {
        loadHospitalAffData()
      }
    })

    const search = (input) => {
      return hospitalaffitems.value.filter((item) => {
        return item.label.toLowerCase().includes(input.toLowerCase())
      })
    }

    const autoCompleteOptions = ref({
      search: search,
      getResultValue: (r) => {
        return r.label
      }
    })

    /**
     * If the user is authenticated and has a profile, we will automatically do a geoLocation on the zip code, then
     * a reverse geoLocation to populate the initialValue of the BaseFCPGeoLocator control.  This will only be done
     * at initial load time to populate the value with the location of zip code on the user's profile.  After that,
     * it is up to the user to interact with the control.
     * 
     * We will only do this if the user is authenticated.
     */
    const calculateInitialvalue = async () => {

      if ( profile.value.isAuthenticated && profile.value.initialZipCode ) {
          const latLongResult = await geoLocate(profile.value.initialZipCode, mapboxToken.value)
          latitude.value = latLongResult.coordinates[1]
          longitude.value = latLongResult.coordinates[0]
          const result = await reverseGeoLocate(latitude.value, longitude.value, mapboxToken.value)
          initialValue.value = result.features[1].place_name
      }
      else {
          initialValue.value = ''
      }
    }

    onMounted(async () => {
        if (context.value.type == 'doctor') loadHospitalAffData()  
    })

    await calculateInitialvalue()

  
</script>
  
<style scoped lang="scss">
  label {
    margin-bottom: var(--spacing-xxs);
    display: block;
  }
</style>